import { useMutation, useQuery, useQueryClient } from "react-query";
import { addMenuAsync, deleteMenuAsync, editMenuAsync, getMenuFullTreeListAsync, getMenuListtAsync, getMenuTreeFormListAsync, getMenuTreeListAsync, getMenuTreeMenuListAsync } from "../api/menu";
import { API_ENDPOINTS } from "../utils/keyapi-endpoints";
import { defaultEmptyGuid } from "../../constants/defaultValues";

export const useGetMenuListQuery = (key: string[], groupId: string) => {
  return useQuery(
    key,
    () => getMenuListtAsync(groupId),
    {
      enabled: true,
    }
  );
};

export const useGetMenuTreeListQuery = (key: string[], groupId: string, enabled=true) => {
  return useQuery(
    key,
    () => getMenuTreeListAsync(groupId),
    {
      enabled: enabled,
    }
  );
};

export const useGetMenuTreeFormListQuery = (key: string[], groupId: string, enabled=true) => {
  return useQuery(
    key,
    () => getMenuTreeFormListAsync(groupId),
    {
      enabled: enabled,
    }
  );
};

export const useGetMenuFullTreeListQuery = (key: string[], groupId: string, enabled=true) => {
  return useQuery(
    key,
    () => getMenuFullTreeListAsync(groupId),
    {
      enabled: enabled,
    }
  );
};

export const useGetMenuTreeMenuListQuery = (key: string[], groupId: string, enabled=true) => {
  return useQuery(
    key,
    () => getMenuTreeMenuListAsync(groupId),
    {
      enabled: enabled,
    }
  );
};

export const useAddMenuQuery = (key: string[]) => {
  const queryClient = useQueryClient()
  return useMutation((item) =>
    addMenuAsync(item),
    {
      // When mutate is called:
      onMutate: async newItem => {
        // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
        await queryClient.cancelQueries(key)

        // Snapshot the previous value
        const previousTodos = queryClient.getQueryData(key)
        // Optimistically update to the new value
        queryClient.setQueryData(key, (old: any) => [...old, newItem])

        // Return a context object with the snapshotted value
        return { previousTodos }
      },
      // If the mutation fails, use the context returned from onMutate to roll back
      onError: (err, newItem, context: any) => {
        queryClient.setQueryData(key, context.previousTodos)
      },
      // Always refetch after error or success:
      onSettled: () => {
        queryClient.invalidateQueries(key)
        queryClient.invalidateQueries(API_ENDPOINTS.UserSecurity)
        queryClient.invalidateQueries(API_ENDPOINTS.RoleSecurity)
        queryClient.invalidateQueries([API_ENDPOINTS.MENU_TREEMENU, defaultEmptyGuid])        
      },
    }
  );
};

export const useEditMenuQuery = (key: string[]) => {
  const queryClient = useQueryClient()
  return useMutation((item) =>
    editMenuAsync(item),
    {
      // When mutate is called:
      onMutate: async newItem => {
        // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
        await queryClient.cancelQueries(key)

        // Snapshot the previous value
        const previousTodos = queryClient.getQueryData(key)

        // Optimistically update to the new value
        queryClient.setQueryData(key, (old: any) => [...old, newItem])

        // Return a context object with the snapshotted value
        return { previousTodos }
      },
      // If the mutation fails, use the context returned from onMutate to roll back
      onError: (err, newItem, context: any) => {
        queryClient.setQueryData(key, context.previousTodos)
      },
      // Always refetch after error or success:
      onSettled: () => {
        queryClient.invalidateQueries(key)
        queryClient.invalidateQueries(API_ENDPOINTS.UserSecurity)
        queryClient.invalidateQueries(API_ENDPOINTS.RoleSecurity)
        queryClient.invalidateQueries([API_ENDPOINTS.MENU_TREEMENU, defaultEmptyGuid])        
      },
    }
  );
};

export const useDeleteMenuQuery = (key: string[]) => {

  const queryClient = useQueryClient()

  return useMutation((itemId: string) =>
    deleteMenuAsync(itemId),
    {
      // When mutate is called:
      onMutate: async newItem => {
        // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
        await queryClient.cancelQueries(key)

        // Snapshot the previous value
        const previousTodos = queryClient.getQueryData(key)

        // Optimistically update to the new value
        queryClient.setQueryData(key, (old: any) => [...old, newItem])

        // Return a context object with the snapshotted value
        return { previousTodos }
      },
      // If the mutation fails, use the context returned from onMutate to roll back
      onError: (err, newItem, context: any) => {
        queryClient.setQueryData(key, context.previousTodos)
      },
      // Always refetch after error or success:
      onSettled: () => {
        queryClient.invalidateQueries(key)
        queryClient.invalidateQueries([API_ENDPOINTS.MENU_TREEMENU, defaultEmptyGuid])
      },
    }
  );
};